import { BaseConvocatoriaService } from "../base/baseApiConvocatoria";

export class ConvocatoriaService extends BaseConvocatoriaService {
  async postConvocatoria(values: any) {
    try {
      const { data } = await this.axiosClient.post(`${process.env.REACT_APP_SERVER_CONV}convocatorias`, values);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }

  async getConvocatoriaById(idConvocatoria: any) {
    try {
      const { data } = await this.axiosClient.get(
        `${process.env.REACT_APP_SERVER_CONV}convocatorias/${idConvocatoria}`
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getConvocatoriaById with stack: ${error}`);
    }
  }

  async obtenerConvocatoriaConEstado(idConvocatoria: any) {
    try {
      const { data } = await this.axiosClient.get(
        `${process.env.REACT_APP_SERVER_CONV}convocatorias/obtenerConvocatoriaConEstado/${idConvocatoria}`
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getConvocatoriaById with stack: ${error}`);
    }
  }

  async getLineaConvocatorias() {
    try {
      const { data } = await this.axiosClient.get('/convocatorias/lineasConvocatorias');
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getLineaConvocatorias with stack: ${error}`);
    }
  }

  async getCategoriasLineaConvocatoria(value: any) {
    try {
      const { data } = await this.axiosClient.get(`/convocatorias/lineasConvocatorias/${value}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getCategoriasLineaConvocatoria with stack: ${error}`);
    }
  }

  async getAllCategoriasLineaConvocatoria() {
    try {
      const { data } = await this.axiosClient.get(
        '/convocatorias/consultarCategoriasLineasConvocatorias'
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getCategoriasLineaConvocatoria with stack: ${error}`);
    }
  }

  async editConvocatoria(idConvocatoria: any, value: any) {
    try {
      const { data } = await this.axiosClient.post(`/convocatorias/${idConvocatoria}`, value);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }

  async getActividades() {
    try {
      const { data } = await this.axiosClient.get('/actividades');
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getActividades with stack: ${error}`);
    }
  }

  async postActividades(idConvocatoria: any, actividades: any) {
    try {
      const { data } = await this.axiosClient.post(
        `/convocatorias/actividades/${idConvocatoria}`,
        actividades
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in postActividades with stack: ${error}`);
    }
  }

  async getActividadesByConvocatoria(idnumero_convocatoria: any) {
    try {
      const { data } = await this.axiosClient.get(
        `/}convocatorias/lineasConvocatorias/${idnumero_convocatoria}`
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getActividadesByConvocatoria with stack: ${error}`);
    }
  }
  
  async getConvocatorias() {
    try {
      const { data } = await this.axiosClient.get('/convocatorias');
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }

  async getConvocatoriasPublicadas() {
    try {
      const { data } = await this.axiosClient.get('/convocatorias/consultarConvocatoriasPublicadas');
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }
  
  async guardarConvocatoriasJurados(values: any) {
    try {
      const { data } = await this.axiosClient.post('/convocatorias/guardarConvocatoriaJurado', values);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }

  async guardarFechas(idconvocatoria: any, values: any) {
    try {
      const { data } = await this.axiosClient.post(`/fechas/guardarFechas/${idconvocatoria}`, values);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }

  async guardarDocumentosadministrativos(idconvocatoria: any, values: any) {
    try {
      const { data } = await this.axiosClient.post(
        `/convocatorias/documentos_generales/${idconvocatoria}`,
        values
      );
      return data;
    } catch (error) {
      return console.error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }
  async cambiarestadoPublicoConvocatorias(idconvocatoria: any, publico: any) {
    try {
      const { data } = await this.axiosClient.put(
        `/convocatorias/cambiarEstadoPublicadoConvocatoria/${idconvocatoria}`,
        { publico: publico }
      );
      return data;
    } catch (error) {
      return console.error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }

  async guardarArchivoPostulacion(filedata: any) {
    console.log(filedata);
    try {
      let { data } = await this.axiosClient.post('/documentos/guardarArchivo', filedata, {
        headers: { "content-type": "multipart/form-data" },
      });
      return data;
    } catch (error) {
      return console.error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }

  async descargarArchivo(url: string) {
    if (url !== "") {
      try {
        let data = await this.axiosClient.get(`documentos/consultarArchivos/${url}`, {
          responseType: "blob",
        });
        return data;
      } catch (error) {
        return console.error(`An unhandled exception in postConvocatoria with stack: ${error}`);
      }
    }
  }

  async getArchivo(url_documento: any) {
    try {
      const data = await this.axiosClient.get(
        `${process.env.REACT_APP_SERVER_CONV}documentos/consultarArchivos/${url_documento}`,
        {
          responseType: "blob",
        }
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
    }
  }

  async consultarNumeroConvocatoria() {
    try {
      const data = await this.axiosClient.get('/convocatorias/numero');
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in getConvocatoriaById with stack: ${error}`);
    }
  }

  async editarConvocatoriasJurados(values: any, convocatoria: number) {
    try {
      const data = await this.axiosClient.put(
        `/convocatorias/actualizarConvocatoriasJurado/${convocatoria}`,
        values
      );
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in editarConvocatoriasJurados with stack: ${error}`);
    }
  }

  async consultarActividadesSeleccionadas(convocatoria: number) {
    try {
      let { data } = await this.axiosClient.get(`/convocatorias/actividades/${convocatoria}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in consultarActividadesSeleccionadas with stack: ${error}`);
    }
  }

  async obtenerDocumentosAdministrativos(id_convocatoria: string) {
    try {
      let { data } = await this.axiosClient.get(`/convocatorias/consultarDocumentosAdministrativos/${id_convocatoria}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerDocumentosAdministrativos with stack: ${error}`);
    }
  }

  async obtenerDocumentosTecnicos(id_convocatoria: string) {
    try {
      let { data } = await this.axiosClient.get(`/convocatorias/consultarDocumentosTecnicos/${id_convocatoria}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerDocumentosTecnicos with stack: ${error}`);
    }
  }

  async consultaConvocatoriasProcesoAbiertas(tipo: number) {
    try {
      let { data } = await this.axiosClient.get(`/convocatorias/consultaConvocatoriasProcesoAbiertas/${tipo}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in consultaConvocatoriasProcesoAbiertas with stack: ${error}`);
    }
  }

  async infoConvocatoria(id_convocatorias: any) {
    try {
      let { data } = await this.axiosClient.get(`/convocatorias/infoConvocatoria/${id_convocatorias}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in consultaConvocatoriasProcesoAbiertas with stack: ${error}`);
    }
  }


  async infoBannerPostulacionConvocatoria(id_convocatorias: any) {
    try {
      let { data } = await this.axiosClient.get(`/convocatorias/infoBannerPostulacionConvocatoria/${id_convocatorias}`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in consultaConvocatoriasProcesoAbiertas with stack: ${error}`);
    }
  }

  async obtenerFechaActual() {
    try {
      const data = await this.axiosClient.get('/fechas/getFechaActual');
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerFechaActual with stack: ${error}`);
    }
  }



}

export default new ConvocatoriaService();